export const categories = [
  {
    id: 'politics',
    name: '政治',
    slug: 'politics',
    description: '改变世界格局的重大政治事件，从革命到外交，深度解析政治风云变幻',
    icon: 'ri-government-line',
    color: 'accent',
  },
  {
    id: 'economy',
    name: '经济',
    slug: 'economy',
    description: '影响全球经济走向的关键事件，金融危机、贸易变革与经济发展里程碑',
    icon: 'ri-money-dollar-circle-line',
    color: 'primary',
  },
  {
    id: 'society',
    name: '社会文化',
    slug: 'society',
    description: '塑造人类文明的社会运动与文化变革，从思想启蒙到文化复兴',
    icon: 'ri-group-line',
    color: 'secondary',
  },
  {
    id: 'technology',
    name: '科技',
    slug: 'technology',
    description: '推动人类进步的重大科技突破，从工业革命到数字时代的技术飞跃',
    icon: 'ri-cpu-line',
    color: 'primary',
  },
  {
    id: 'military',
    name: '军事',
    slug: 'military',
    description: '改变世界版图的重大战争与军事冲突，深度剖析战争背后的历史逻辑',
    icon: 'ri-shield-line',
    color: 'accent',
  },
];